import type { Transport } from 'viem'

import { isPerfEnabled, recordRpc } from './stats'

/**
 * Wrap a viem Transport so every JSON-RPC call contributes to __perf.rpc().
 *
 * Passes through unchanged in production, or whenever the perf flag is off,
 * so there is no runtime cost for end users.
 */
export function instrumentTransport(transport: Transport): Transport {
  if (!isPerfEnabled()) return transport

  return ((args) => {
    const inner = transport(args)
    const originalRequest = inner.request

    const wrappedRequest: typeof inner.request = (async (req) => {
      const method = (req as { method?: string })?.method ?? 'unknown'
      const start = typeof performance !== 'undefined' ? performance.now() : Date.now()
      try {
        const result = await originalRequest(req)
        recordRpc(method, nowMs(start), true)
        return result
      } catch (err) {
        recordRpc(method, nowMs(start), false)
        throw err
      }
    }) as typeof inner.request

    return {
      ...inner,
      request: wrappedRequest,
    }
  }) as Transport
}

function nowMs(start: number): number {
  const end = typeof performance !== 'undefined' ? performance.now() : Date.now()
  return end - start
}
